export default __webpack_public_path__ + "static/media/Backback-Remove.d60ea3ae.svg";